import styled from "styled-components";
import type { Theme } from "../../constants/themeConstants";
import { Box } from "@mui/material";
import { SocialNetworksContainer } from "../Header/SocialNetworks/SocialNetworks.styled";

export const StyledFooter = styled.footer`
  background-color: ${(props) => (props.theme as Theme).colors?.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;

  @media (max-width: 768px) {
    padding: 80px 16px 32px 16px;
  }
`;

export const FooterText = styled.p`
  margin: 0;
  font-size: 14px;
  color: #333;
  margin-block-start: 0;
  margin-block-end: 0;
`;

export const CopyrightSection = styled(Box)`
  width: calc(min(100% - 96px, 1280px));

  margin: 0 80px 48px 80px;
  padding-top: 48px;

  color: ${(props) => (props.theme as Theme).colors?.textColor};
  border-top: 1px solid ${(props) => (props.theme as Theme).colors?.gray};

  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  font-size: 14px;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  line-height: 140%;
  a {
    color: ${(props) => (props.theme as Theme).colors?.textColor};
    text-decoration: underline;
  }

  > :last-child {
    flex-basis: 100%;
    color: ${(props) => (props.theme as Theme).colors?.lightTextColor};

    font-size: 12px;
    text-align: right;

    a {
      color: ${(props) => (props.theme as Theme).colors?.lightTextColor};
      text-decoration: underline;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    padding-top: 28px;

    display: flex;
    flex-direction: column;

    margin-bottom: 0;

    ${SocialNetworksContainer} {
      order: -1;
    }

    > :last-child {
      text-align: left;
    }
  }

  @media (max-width: 1280px) {
    padding-top: 28px;

    display: flex;
    flex-direction: column;

    margin-bottom: 28px;

    ${SocialNetworksContainer} {
      order: -1;
    }

    > :last-child {
      text-align: left;
    }
  }
`;

export const FooterLinks = styled(Box)`
  display: flex;
`;

export const FooterContent = styled(Box)`
  width: calc(min(100% - 96px, 1280px));
  margin: 48px auto 0 auto;
  padding: 48px 0 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  row-gap: 20px;

  @media (max-width: 768px) {
    row-gap: 24px;
    margin: 0;
    padding: 0;
    width: 100%;
  }
`;

export const LogoContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled.picture`
  width: auto;
`;
